// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__327yj","rootMobile":"styles_rootMobile__14Jvx"};